import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import { Card, CardBody, Form, FormGroup, InputGroup, Label } from "reactstrap";
import Flatpickr from "react-flatpickr";

import DataComponent from "../../components/DataComponent";
import { FLATPICKR_DATE_LOCALE } from "../../constants/DAY";

const TestDatePicker = (props) => {
  const [options] = useState({
    type: "customdatepicker",
    onChange: (dates) => { },
  });

  return (
    <div className="test-page">
      <PageHeader title="WeCake - Date Picker" />

      <Card>
        <CardBody>
          <h4 className="card-title">Custom Datepicker</h4>
          <br />

          <Form>
            <FormGroup className="mb-4">
              <Label>Custom Datepicker</Label>
              <InputGroup>
                <DataComponent field={options} />
              </InputGroup>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h4 className="card-title">Datepicker</h4>
          <br />

          <Form>
            <FormGroup className="mb-4">
              <Label>Default Functionality</Label>
              <InputGroup>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="dd M,yyyy"
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                  

                />
              </InputGroup>
            </FormGroup>
            <div className="form-group mb-4">
              <Label>Auto Close</Label>
              <InputGroup>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="dd M,yyyy"
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
              </InputGroup>
            </div>

            <div className="form-group mb-4">
              <label>Multiple Date</label>
              <div className="input-group">
                <Flatpickr
                  className="form-control d-block"
                  placeholder="dd M,yyyy"
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    mode: "multiple",
                    dateFormat: "Y-m-d",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
              </div>
            </div>

            <FormGroup className="mb-4">
              <Label>Date Range</Label>
              <InputGroup>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="dd M,yyyy"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
              </InputGroup>
            </FormGroup>

            <div className="form-group mb-0">
              <label>Inline Datepicker</label>
              <Flatpickr
                className="form-control d-block"
                placeholder="dd M,yyyy"
                options={{
                  inline: true,
                  altInput: true,
                  altFormat: "F j, Y",
                  dateFormat: "Y-m-d",
                  locale: FLATPICKR_DATE_LOCALE
                }}
              />
            </div>
          </Form>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h4 className="card-title">Timepicker</h4>
          <br />

          <Form action="#">
            <FormGroup className="mb-3">
              <Label>Default Time Picker</Label>

              <InputGroup>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Select time"
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="mdi mdi-clock-outline" />
                  </span>
                </div>
              </InputGroup>
            </FormGroup>
            <div className="form-group mb-3">
              <Label>24 Hour Mode Time Picker</Label>

              <InputGroup>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Select time"
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    time_24hr: true,
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="mdi mdi-clock-outline" />
                  </span>
                </div>
              </InputGroup>
            </div>

            <div className="form-group mb-0">
              <label>Specify a step for the minute field</label>

              <div className="input-group">
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Select time"
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    locale: FLATPICKR_DATE_LOCALE
                  }}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="mdi mdi-clock-outline" />
                  </span>
                </div>
              </div>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default TestDatePicker;
